import { useTranslation } from 'react-i18next';
import Button from '../../../../../../../../common/widgets/Button';
import Dialog from '../../../../../../../../common/widgets/Dialog';
import { ProductListModel } from '../../../../../../models/Product';
import { resources } from '../../../../../../resources/resources';
import { FilterPanelModel } from '../../../../../CategoryPage/types';
import FilterPanel from '../../../../../Common/Filters';

interface IFilterDialogProps {
  closeDialog: () => void;
  filters: FilterPanelModel;
  filteredProductList?: ProductListModel[];
}

const FilterDialog = (props: IFilterDialogProps) => {
  const { closeDialog, filters, filteredProductList } = props;
  const { t: translate } = useTranslation();

  const handleCancel = () => {
    filters.clearFilters();
    closeDialog();
  };

  return (
    <Dialog
      closeDialog={closeDialog}
      showCloseIcon
      headerContent={
        <div className="dialog-title">
          {translate(resources.searchPage.filter)}
        </div>
      }
      className="dialog-m mobile-filter-dialog"
    >
      <div className="dialog-content filter-content mobile-forms">
        <FilterPanel
          availableInList={filters?.filteredAvailableInList}
          brandList={filters?.filteredBrandList}
          buyerTypeList={filters?.filteredBuyerTypeList}
          taxationLevelList={filters?.filteredTaxationLevelList}
          employerTaxationLevelList={filters?.filteredEmployerTaxationLevelList}
          priceRange={filters?.priceRange}
          discountedProdutsCount={filters?.discountedProductsCount}
          prevSelectionState={filters.selectionFilterState}
          hasActiveFilters={filters.hasActiveFilters}
          handleAvailableInFilterChanged={filters.availableInFilterChanged}
          handleBrandFilterChanged={filters.brandFilterChanged}
          handleBuyerTypeFilterChanged={filters.buyerTypeFilterChanged}
          handlePriceRangeFilterChanged={filters.priceRangeFilterChanged}
          handleProductsOnOfferFilterChanged={
            filters.productsOnOfferFilterChanged
          }
          handleTaxFilterChanged={filters.taxFilterChanged}
          handleEmployerTaxFilterChanged={filters.employerTaxFilterChanged}
          handleClearFilters={filters.clearFilters}
          filteredProducts={filteredProductList}
        />
      </div>
      <div className="dialog-actions">
        <Button
          className="btn btn-outline"
          disabled={!filters.hasActiveFilters}
          onClick={handleCancel}
        >
          {translate(resources.searchPage.cancel)}
        </Button>
        <Button className="btn btn-solid" onClick={closeDialog}>
          {translate(resources.searchPage.checkProducts)}
        </Button>
      </div>
    </Dialog>
  );
};

export default FilterDialog;
